import { CoreMenu } from 'src/@core/types';

export const crmMenu: CoreMenu[] = [
  {
    id: 'customers',
    title: 'Customers',
    type: 'item',
    url: 'lead-konnekt/customers',
    role: { roles: ['employee'], module: 'customers', right: 'view' },
  },
  {
    id: 'tickets',
    title: 'Tickets',
    type: 'item',
    url: 'lead-konnekt/tickets',
    role: {
      roles: ['employee', 'customer'],
      module: 'tickets',
      right: 'view',
    },
  },
];
